import { render, staticRenderFns } from "./importMercados.vue?vue&type=template&id=3351174e&scoped=true"
import script from "./importMercados.vue?vue&type=script&lang=js"
export * from "./importMercados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3351174e",
  null
  
)

export default component.exports